import { ILocation } from 'src/app/features/customers/models/customers.models';

/** One identifier code of a location, outside the per-type grouping. */
export interface ILocationCodeTag {
  type: string;
  value: string;
}

/**
 * A location's identifier codes as one entry per value, so every code gets its
 * own tag — a type can hold several values, and `tax_id` only ever carried the
 * first VAT one.
 */
export function locationCodeTags(location?: ILocation | null): ILocationCodeTag[] {
  return (location?.codes ?? []).flatMap((code) =>
    (code.values ?? []).map((value) => ({ type: code.type, value }))
  );
}
